import * as React from 'react';
import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { computed } from "mobx";
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import get from 'lodash/get';
import Translate from './Translate';
import Commentaries from './Commentaries';
import { DataStore } from '../stores';

const FundCommentaryWrapper = styled<any, any>('article')`
    ${propStyles};
`;

FundCommentaryWrapper.defaultProps = {
};

const FundCommentaryHeading = styled<any, any>('h2')`
    ${propStyles};
`;

FundCommentaryHeading.defaultProps = {
    color: "body",
    fontFamily: "heading",
    fontWeight: "bold",
    fontSize: "md"
};

type TCommentariesDictionary = {
    [property: string]: string;
};

type TCommentariesType = {
    commentaryType: string;
};

type TFundCommentary = {
    label: string;
    commentaries: Array<TCommentariesType>
};

interface FundCommentaryProps {
    theme?: { [property: string]: string | number };
    dataStore?: DataStore;
    showHeading: boolean;
    fundCommentary: TFundCommentary;
    shareClass: any; // TODO: Make a share class type, likely composed of many other types
    commentaries?: Array<string>;
}

@inject('dataStore')
@observer
class FundCommentary extends Component<FundCommentaryProps> {
    @computed
    get commentariesDictionary(): TCommentariesDictionary {
        const commentariesDictionary = {};
        const { commentaries = {} } = this.props.shareClass;

        for (let c in commentaries) {
            if (c) {
                const { commentary = '' } = 
                    commentaries[c].find(cc => cc.culture === this.props.dataStore.culture) || 
                    commentaries[c].find(cc => cc.culture === this.props.dataStore.config.defaultCulture) || 
                    {};
                commentariesDictionary[c] = commentary;
            }
        }

        return commentariesDictionary;
    }

    @computed
    get commentaries(): Array<string> {
        return this.getCommentaries(this.props.fundCommentary.commentaries);
    }

    getCommentaries = (commentaryTypes: Array<TCommentariesType> = []): Array<string> => {
        const commentaries = commentaryTypes
            .map(d => get(this.commentariesDictionary, d.commentaryType))
            .filter(d => d !== undefined);
        return commentaries;
    }

    render() {
        const { theme, showHeading, fundCommentary } = this.props;
        const { commentaries } = this;

        return (
            <FundCommentaryWrapper
                {...theme.FundCommentaryWrapper}
            >
                {
                    showHeading && (
                        <FundCommentaryHeading
                            {...theme.FundCommentaryHeading}
                        >
                            <Translate>{fundCommentary.label}</Translate>
                        </FundCommentaryHeading>
                    )
                }
                <Commentaries
                    commentaries={commentaries}
                    {...theme.FundCommentaryContent}
                />
            </FundCommentaryWrapper>
        );
    }
}

export default withTheme(FundCommentary);


// WEBPACK FOOTER //
// ./src/Components/FundCommentary.tsx